import styled from "styled-components";

import { CategoryItem } from "app/components/React/CategoriesDropdown/CategoryDropdown";
import { FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";

export const Right = styled(FlexRow)`
    flex-grow: 0;
    align-items: center;
    margin-left: 10px;
`;

export const CategoryItemContainer = styled(CategoryItem)`
    font-weight: 400;
`;

export const SectionContainer = styled.div`
    padding: 16px;
    display: flex;
    align-items: center;
    gap: 16px;
`;
